import { UnderlineTab, UnderlineTabs } from "@/components/ui/underline-tabs";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./view-toggle.i18n";

export type PortfolioView = "list" | "grid";

type PortfolioViewToggleProps = {
  view: PortfolioView;
  onChange: (view: PortfolioView) => void;
};

/** The List / Grid switch above a portfolios tab (model and dynamic). */
export function PortfolioViewToggle({ view, onChange }: PortfolioViewToggleProps) {
  const t = useT(T);

  const tabs: { key: PortfolioView; label: string }[] = [
    { key: "list", label: t.list },
    { key: "grid", label: t.grid },
  ];

  return (
    <UnderlineTabs className="gap-4 mb-4">
      {tabs.map((tab) => (
        <UnderlineTab
          key={tab.key}
          label={tab.label}
          active={view === tab.key}
          onClick={() => onChange(tab.key)}
        />
      ))}
    </UnderlineTabs>
  );
}
